const toNullableString = (value) => {
  if (value === undefined) {
    return undefined;
  }

  if (value === null || String(value).trim() === '') {
    return null;
  }

  return String(value).trim();
};

export const mapSubmitProjectPayload = (payload) => ({
  ...(payload.companyName ? { companyName: payload.companyName } : {}),
  partnerName: payload.partnerName,
  partnerEmail: payload.partnerEmail,
  csn: payload.csn,
  customerName: payload.customerName,
  projectLeadName: payload.projectLeadName,
  projectLeadEmail: payload.projectLeadEmail,
  productsInScope: payload.productsInScope || [],
  engagementType: payload.engagementType,
  deploymentModel: payload.deploymentModel,
  projectStatus: payload.projectStatus,
  estimatedStartDate: payload.estimatedStartDate,
  estimatedGoliveDate: payload.estimatedGoliveDate,
  actualStartDate: toNullableString(payload.actualStartDate),
  actualGoliveDate: toNullableString(payload.actualGoliveDate),
  projectDescription: payload.projectDescription,
  competitiveContext: payload.competitiveContext || '',
  additionalNotes: payload.additionalNotes || '',
});

export const mapUpdateProjectPayload = (payload) => ({
  customerName: payload.customerName,
  projectLeadName: payload.projectLeadName,
  projectLeadEmail: payload.projectLeadEmail,
  productsInScope: payload.productsInScope || [],
  engagementType: payload.engagementType,
  deploymentModel: payload.deploymentModel,
  projectStatus: payload.projectStatus,
  estimatedStartDate: payload.estimatedStartDate,
  estimatedGoliveDate: payload.estimatedGoliveDate,
  actualStartDate: toNullableString(payload.actualStartDate),
  actualGoliveDate: toNullableString(payload.actualGoliveDate),
  projectDescription: payload.projectDescription,
  competitiveContext: payload.competitiveContext || '',
  additionalNotes: payload.additionalNotes || '',
});

export const mapPAEUpdateProjectPayload = (payload) => ({
  partnerName: payload.partnerName,
  partnerEmail: payload.partnerEmail,
  companyName: payload.companyName,
  csn: payload.csn,
  customerName: payload.customerName,
  projectLeadName: payload.projectLeadName,
  projectLeadEmail: payload.projectLeadEmail,
  productsInScope: payload.productsInScope || [],
  engagementType: payload.engagementType,
  deploymentModel: payload.deploymentModel,
  estimatedStartDate: payload.estimatedStartDate,
  estimatedGoliveDate: payload.estimatedGoliveDate,
  actualStartDate: toNullableString(payload.actualStartDate),
  actualGoliveDate: toNullableString(payload.actualGoliveDate),
  projectDescription: payload.projectDescription,
  competitiveContext: payload.competitiveContext || '',
  additionalNotes: payload.additionalNotes || '',
  actualCustomerName: toNullableString(payload.actualCustomerName),
  actualCustomerCsn: toNullableString(payload.actualCustomerCsn),
  salesforceOpportunityId: toNullableString(payload.salesforceOpportunityId),
});

export const mapProjectToForm = (project) => ({
  partnerName: project.partnerName || '',
  csn: project.csn || '',
  customerName: project.customerName || '',
  projectLeadName: project.projectLeadName || '',
  projectLeadEmail: project.projectLeadEmail || '',
  productsInScope: project.productsInScope || [],
  engagementType: project.engagementType || '',
  deploymentModel: project.deploymentModel || '',
  projectStatus: project.projectStatus || '',
  estimatedStartDate: project.estimatedStartDate || '',
  estimatedGoliveDate: project.estimatedGoliveDate || '',
  actualStartDate: project.actualStartDate || '',
  actualGoliveDate: project.actualGoliveDate || '',
  completedDate: project.completedDate || '',
  projectDescription: project.projectDescription || '',
  competitiveContext: project.competitiveContext || '',
  additionalNotes: project.additionalNotes || '',
});

export const mapPAEProjectToForm = (project) => ({
  ...mapProjectToForm(project),
  companyName: project.companyName || '',
  partnerEmail: project.partnerEmail || '',
  actualCustomerName: project.actualCustomerName || '',
  actualCustomerCsn: project.actualCustomerCsn || '',
  salesforceOpportunityId: project.salesforceOpportunityId || '',
});

// Legacy alias kept for any remaining references.
export const mapCreateProjectPayload = mapSubmitProjectPayload;
